import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import PostMioLogo from '../components/PostMioLogo'

const G = {
  bg:       '#0A0A0A',
  base:     '#111111',
  card:     '#1A1A1A',
  border:   '#2C2C2C',
  gold:     '#C9922A',
  goldLt:   '#E5B050',
  goldGlow: 'rgba(201,146,42,0.12)',
  cream:    '#F0EDE8',
  textSec:  '#A0A0A0',
  textMut:  '#606060',
  smoke:    '#7A7A7A',
}

const TM = () => (
  <sup style={{ fontSize: '0.5em', verticalAlign: 'super', lineHeight: 0 }}>™</sup>
)

export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0) }, [])
  return (
    <div style={{ background: G.bg, minHeight: '100vh', fontFamily: "'DM Sans', sans-serif", color: G.cream }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Lora:wght@700&family=DM+Sans:wght@400;500;600&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${G.bg}; }
        .pp-link { color: ${G.gold}; text-decoration: none; }
        .pp-link:hover { color: ${G.goldLt}; }
        .pp-table-wrap { overflow-x: auto; width: 100%; }
        .pp-table { width: 100%; border-collapse: collapse; font-size: 14px; }
        .pp-table th, .pp-table td { border: 1px solid ${G.border}; padding: 10px 14px; text-align: left; }
        .pp-table th { background: ${G.card}; color: ${G.cream}; font-family: 'DM Sans', sans-serif; font-weight: 600; }
        .pp-table td { color: ${G.textSec}; }
        .pp-table tbody tr:nth-child(even) td { background: rgba(26,26,26,0.5); }
        .pp-ul { list-style: none; padding: 0; margin: 0; }
        .pp-ul li { color: ${G.textSec}; font-size: 15px; line-height: 1.7; padding: 4px 0 4px 20px; position: relative; }
        .pp-ul li::before { content: '•'; color: ${G.gold}; position: absolute; left: 0; }
        .land-section-tag {
          display: inline-block;
          background: rgba(201,146,42,0.12);
          border: 1px solid rgba(201,146,42,0.35);
          color: ${G.gold};
          border-radius: 20px;
          padding: 4px 14px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 1px;
          text-transform: uppercase;
          font-family: 'DM Sans', sans-serif;
        }
      `}</style>

      {/* ── NAVBAR ─────────────────────────────────────────────── */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(10,10,10,0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${G.border}`,
        padding: '0 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 60,
      }}>
        <Link to="/" style={{ textDecoration: 'none', lineHeight: 0 }}>
          <PostMioLogo size="md" variant="dark" />
        </Link>
        <Link
          to="/"
          style={{ fontSize: 14, color: G.textSec, textDecoration: 'none', fontWeight: 500, transition: 'color 0.2s' }}
          onMouseEnter={e => e.currentTarget.style.color = G.cream}
          onMouseLeave={e => e.currentTarget.style.color = G.textSec}
        >
          ← Back
        </Link>
      </nav>

      {/* ── PAGE HEADER ────────────────────────────────────────── */}
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '64px 24px 0' }}>
        <span className="land-section-tag">Privacy Policy</span>

        <h1 style={{
          fontFamily: "'Lora', serif",
          fontWeight: 700,
          fontSize: 'clamp(28px, 4vw, 44px)',
          color: G.cream,
          lineHeight: 1.25,
          marginTop: 20,
          marginBottom: 12,
        }}>
          Privacy Policy<br />
          <span style={{ color: G.gold }}>PostMio<TM /></span>
        </h1>

        <p style={{ fontSize: 14, color: G.textMut, marginBottom: 32 }}>
          Last updated: 16 March 2026
        </p>

        <div style={{ borderTop: `1px solid ${G.border}`, marginBottom: 40 }} />

        {/* ── 1. Controller ─────────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          1. Controller
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7 }}>
          PostMio™ is operated by Alexander Primavera, Italy.
          Contact: <a className="pp-link" href="mailto:support@postmio.it">support@postmio.it</a>
        </p>

        {/* ── 2. Data Collected ─────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          2. Data Collected
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7, marginBottom: 16 }}>
          We collect only what is necessary to provide the service.
        </p>
        <div className="pp-table-wrap">
          <table className="pp-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Why</th>
                <th>Legal Basis</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Email address</td><td>Account creation + communication</td><td>Contract performance</td></tr>
              <tr><td>Name</td><td>Personalisation</td><td>Contract performance</td></tr>
              <tr><td>Business type + language</td><td>AI output customisation</td><td>Contract performance</td></tr>
              <tr><td>Payment data</td><td>Subscription billing</td><td>Contract performance</td></tr>
              <tr><td>Generated content (posts, review replies)</td><td>Service delivery</td><td>Contract performance</td></tr>
              <tr><td>Reviews submitted</td><td>Public testimonials (if approved)</td><td>Consent</td></tr>
              <tr><td>IP address + usage logs</td><td>Security + abuse prevention</td><td>Legitimate interest</td></tr>
            </tbody>
          </table>
        </div>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7, marginTop: 16 }}>
          Your payment data is processed exclusively by Stripe. PostMio never stores card details.
        </p>

        {/* ── 3. Third-Party Processors ─────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          3. Third-Party Processors
        </h2>
        <div className="pp-table-wrap">
          <table className="pp-table">
            <thead>
              <tr>
                <th>Processor</th>
                <th>Purpose</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Stripe</td><td>Payment processing</td><td>USA (EU SCC)</td></tr>
              <tr><td>Supabase</td><td>Auth + database</td><td>EU (Ireland)</td></tr>
              <tr><td>Vercel</td><td>Hosting + serverless</td><td>USA (EU SCC)</td></tr>
              <tr><td>Resend</td><td>Transactional email</td><td>USA (EU SCC)</td></tr>
              <tr><td>Anthropic</td><td>AI content generation</td><td>USA (EU SCC)</td></tr>
              <tr><td>ImprovMX</td><td>Email forwarding</td><td>EU</td></tr>
            </tbody>
          </table>
        </div>

        {/* ── 4. Data Retention ─────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          4. Data Retention
        </h2>
        <ul className="pp-ul">
          <li>Active account: retained for subscription duration + 12 months</li>
          <li>Cancelled account: email + billing records retained 5 years (Italian fiscal law)</li>
          <li>Generated posts: not stored — processed in real time, never saved</li>
          <li>Reviews: retained indefinitely unless deletion requested</li>
        </ul>

        {/* ── 5. Your Rights ────────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          5. Your Rights (GDPR Art. 15–22)
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7, marginBottom: 12 }}>
          You have the right to: access, rectify, erase, restrict processing, data portability, and object to processing.
        </p>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7, marginBottom: 12 }}>
          To exercise any right: <a className="pp-link" href="mailto:support@postmio.it">support@postmio.it</a> — response within 30 days.
        </p>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7 }}>
          You may also lodge a complaint with the Italian data protection authority: Garante per la protezione dei dati personali —{' '}
          <a className="pp-link" href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>
        </p>

        {/* ── 6. Cookies ────────────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          6. Cookies
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7 }}>
          PostMio uses only technically necessary cookies for session management. No advertising or tracking cookies. No third-party analytics.
        </p>

        {/* ── 7. Data Transfers ─────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          7. Data Transfers
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7 }}>
          Where data is transferred outside the EU (Stripe, Vercel, Anthropic, Resend), transfers are covered by Standard Contractual Clauses (SCCs) approved by the European Commission.
        </p>

        {/* ── 8. Children ───────────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          8. Children
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7 }}>
          PostMio is not directed at persons under 18. No data from minors is knowingly collected.
        </p>

        {/* ── 9. Changes ────────────────────────────────────────── */}
        <h2 style={{ fontFamily: "'Lora', serif", fontWeight: 700, fontSize: 20, color: G.cream, marginTop: 40, marginBottom: 12 }}>
          9. Changes
        </h2>
        <p style={{ fontSize: 15, color: G.textSec, lineHeight: 1.7, marginBottom: 64 }}>
          Material changes will be notified via email at least 14 days before taking effect.
        </p>
      </div>

      {/* ── FOOTER ─────────────────────────────────────────────── */}
      <footer style={{ background: G.bg, borderTop: `1px solid ${G.border}`, padding: '40px 24px', textAlign: 'center' }}>
        <PostMioLogo size="md" variant="dark" />
        <p style={{ fontSize: 14, color: G.textMut, marginTop: 16, lineHeight: 1.5 }}>
          The social media tool built for small business owners.<br />
          <Link to="/about" style={{ color: G.textMut, textDecoration: 'none' }}>About</Link>
          {' · '}
          <Link to="/reviews" style={{ color: G.textMut, textDecoration: 'none' }}>Reviews</Link>
          {' · '}
          <Link to="/login" style={{ color: G.textMut, textDecoration: 'none' }}>Login</Link>
        </p>
        <p style={{ fontSize: 13, color: G.border, marginTop: 12, lineHeight: 1.5 }}>
          © {new Date().getFullYear()} PostMio<TM /> · P.IVA in corso di registrazione
        </p>
      </footer>
    </div>
  )
}
